import React, { useCallback, useEffect } from 'react';
import { VbzHeaderPlaceholder, VbzButton } from '@smiles/voebiz-ui-kit';
import { useTranslation, Trans } from 'react-i18next';
import { Params } from './types';

const DefaultMsgPage: React.FC<Params> = ({
  traductionKey = '',
  image,
  traductionContentParams,
  isPrimaryLoading = false,
  onPrimary,
  onSecondary,
  children,
}) => {
  const { t, i18n } = useTranslation(traductionKey);

  const renderButton = useCallback(() => {
    if (!onPrimary && !onSecondary) {
      return null;
    }

    return (
      <div className="smls-components-message-container-buttons">
        {onPrimary && <VbzButton text={t('btn_primary')} onClick={onPrimary} isLoading={isPrimaryLoading} />}
        {onSecondary && <VbzButton text={t('btn_secondary')} onClick={onSecondary} color="hyperlink" />}
      </div>
    );
  }, [onPrimary, onSecondary, t, isPrimaryLoading]);

  const renderSub = useCallback(() => {
    const traduction = t('content_sub');
    if (traduction === 'content_sub') {
      return null;
    }

    return <p>{traduction}</p>;
  }, [t]);

  const getClassIcon = useCallback(() => {
    switch (image) {
      case 'beachChair':
        return 'voebiz-icon-beach_chair';
      case 'brokenSuitcase':
        return 'voebiz-icon-broken_suitcase';
      case 'cellPhone':
        return 'voebiz-icon-cell_phone';
      case 'email':
        return 'voebiz-icon-email';
      case 'profile':
        return 'voebiz-icon-profile';
      default:
        return '';
    }
  }, [image]);

  useEffect(() => {
    i18n.init();
  }, [traductionKey]);

  return (
    <div className="smls-components-message">
      <VbzHeaderPlaceholder redirectUrl={window.location.origin} />
      <div className="smls-components-message-container">
        <div>
          <div className={`image ${getClassIcon()}`} />
          <div className="smls-components-message-container-content">
            <h3>{t('header')}</h3>
            <p>
              <Trans t={t} i18nKey="content" values={traductionContentParams} components={{ bold: <b /> }} />
            </p>
            {renderSub()}
            {renderButton()}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DefaultMsgPage;
